import auth from "@/router/middleware/auth";
import guest from "@/router/middleware/guest";
import hasAccess from "@/router/middleware/hasAccess";
import personAccessToView from "@/router/middleware/personAccessToView";

export default {
  auth,
  guest,
  hasAccess,
  personAccessToView,
};
